import { gql } from '@apollo/client';

export const FILTERED_ECD_CIRCUITS = gql`
  query FilteredECDCircuits($input: CircuitsInput) {
    circuits: filteredECDCircuits(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
